à<template>
  <div class="w-full min-h-screen flex flex-col">
    <MainNav />
    <section class="w-full relative">
      <img
        src="/image/83islands_collections.jpg"
        alt="83 Islands Collections"
        class="w-full h-[800px] object-cover object-[bottom_center] md:object-center"
      />

      <!-- Text Overlay -->
      <div class="mx-auto absolute mt-36 inset-0 z-20 w-full p-4 lg:p-36 flex flex-col items-center lg:items-start pointer-events-none">
        <h1 class="text-white font-maax text-4xl uppercase lg:text-6xl font-bold text-center lg:text-left max-w-3xl leading-tight drop-shadow-[0_5px_5px_rgba(0,0,0,0.3)] pointer-events-auto">
          Collections
        </h1>
        <p class="text-white font-maax text-xl lg:text-2xl mt-4 text-center lg:text-left max-w-3xl drop-shadow-[0_5px_5px_rgba(0,0,0,0.3)] pointer-events-auto">
          Discover our exclusive collections of exceptional spirits from Vanuatu.
        </p>
      </div>

      <!-- Double Wave -->
      <div class="absolute -bottom-1 left-0 right-0 w-full overflow-hidden">
        <svg viewBox="0 0 1200 120" preserveAspectRatio="none" class="w-full h-20 text-white">
          <path d="M985.66,92.83C906.67,72,823.78,31,743.84,14.19c-82.26-17.34-168.06-16.33-250.45.39-57.84,11.73-114,31.07-172,41.86A600.21,600.21,0,0,1,0,27.35V120H1200V95.8C1132.19,118.92,1055.71,111.31,985.66,92.83Z"
                fill="currentColor" class="opacity-25"/>
          <path d="M985.66,92.83C906.67,72,823.78,31,743.84,14.19c-82.26-17.34-168.06-16.33-250.45.39-57.84,11.73-114,31.07-172,41.86A600.21,600.21,0,0,1,0,27.35V120H1200V95.8C1132.19,118.92,1055.71,111.31,985.66,92.83Z"
                fill="currentColor"/>
        </svg>
      </div>
    </section>

    <main class="flex-grow w-full bg-white">
      <div class="container mx-auto p-4 lg:p-8">
        <!-- Collections Grid - 2 rows of 4 -->
        <div class="grid grid-cols-2 md:grid-cols-4 gap-4 lg:gap-8 mt-12 mb-16 max-w-6xl mx-auto">
          <router-link
            v-for="(collection, index) in collections"
            :key="index"
            :to="collection.route"
            class="group relative flex flex-col items-center p-4 lg:p-6 bg-white hover:bg-gray-50"
          >
            <!-- Collection Badge -->
            <div class="w-full aspect-square flex items-center justify-center mb-4">
              <img
                :src="collection.badge"
                :alt="collection.name"
                class="w-full h-full object-contain"
              />
            </div>

            <!-- Collection Name -->
            <h2 class="font-maax text-sm lg:text-base font-bold uppercase text-black text-center group-hover:text-gold mb-2">
              {{ collection.name }}
            </h2>

            <!-- Description -->
            <p class="font-maax text-xs text-gray-600 text-center mb-2 px-2">
              {{ collection.description }}
            </p>

            <!-- Status Badge -->
            <div v-if="collection.status" class="mt-2">
              <span
                :class="[
                  'inline-block font-maax text-xs uppercase px-2 py-1 border border-black',
                  collection.status === 'available' ? 'bg-white text-black' :
                  collection.status === 'coming soon' ? 'bg-gray-100 text-black' : ''
                ]"
              >
                {{ collection.status }}
              </span>
            </div>
          </router-link>
        </div>
      </div>
    </main>

    <Footer class="relative" />
  </div>
</template>

<script setup>
import { ref } from 'vue'
import MainNav from '../components/MainNav.vue'
import Footer from '../components/Footer.vue'

const collections = ref([
  {
    name: 'Haos Collection',
    description: 'Bar exclusives made for mixing and sharing.',
    route: '/collections/haos',
    status: 'available',
    badge: '/image/collections/HaosCollection.svg'
  },
  {
    name: 'First Press Collection',
    description: 'Pure origin cane juice rum.',
    route: '/collections/first-press',
    status: 'available',
    badge: '/image/collections/FirstPressCollection.svg'
  },
  {
    name: 'Nabanga Collection',
    description: 'The first sip: young, bold, approachable.',
    route: '/collections/nabanga',
    status: 'available',
    badge: '/image/collections/NabangaCollection.svg'
  },
  {
    name: 'Spiced Rum Collection',
    description: 'Bold and aromatic spiced creations.',
    route: '/collections/spiced-rum',
    status: 'available',
    badge: '/image/collections/SpicedRumCollection.svg'
  },
  {
    name: 'Kalakala Collection',
    description: 'Colourful liqueurs, gin, and flavoured rum.',
    route: '/collections/kalakala',
    status: 'available',
    badge: '/image/collections/KalakalaCollection.svg'
  },
  {
    name: 'Lapita Collection',
    description: 'Specialty cask blends made for consistency.',
    route: '/collections/lapita',
    status: 'available',
    badge: '/image/collections/LapitaCollection.svg'
  },
  {
    name: 'Single Cask Collection',
    description: 'Rare casks chosen for distinction.',
    route: '/collections/single-cask',
    status: 'available',
    badge: '/image/collections/SingleCaskCollection.svg'
  },
  {
    name: 'Storian Collection',
    description: 'Stories captured in bottles.',
    route: '/collections/storian',
    status: 'available',
    badge: '/image/collections/StorianCollection.svg'
  }
])
</script>
